const PAGE_COUNT_STORAGE_KEY = 'projectsPageCount'
const DEFAULT_PAGE_COUNT = 16
const COVER_PAGE_COUNT = 2

// Assumed page count to show skeleton pages. Calculated based on the previous load.
export const useAssumedPageCount = ({
  projectId
}: {
  projectId: string
}) => {
  const map = JSON.parse(
    localStorage.getItem(PAGE_COUNT_STORAGE_KEY) || '{}'
  )

  const assumedPageCount =
    (map[projectId] || DEFAULT_PAGE_COUNT) + COVER_PAGE_COUNT

  const savePageCount = (pageCount: number) => {
    map[projectId] = pageCount
    localStorage.setItem(PAGE_COUNT_STORAGE_KEY, JSON.stringify(map))
  }

  return { assumedPageCount, savePageCount }
}
